import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { ALL_APPS, type AppContextValue } from '../../lib/appConstants';

// Globaler App-Kontext des Admins: welche Lern-App ist im Fokus?
// - "Alle Apps" (Default) für app-übergreifende Sichten (User-Liste).
// - Eine konkrete App scoped Sichten + liefert die Ziel-App app-gebundener
//   Aktionen (Broadcast). Persistiert, damit die Wahl einen Reload überlebt.

interface AppContextState {
  appId: AppContextValue;
  setAppId: (appId: AppContextValue) => void;
}

export const useAppContextStore = create<AppContextState>()(
  persist(
    (set) => ({
      appId: ALL_APPS,
      setAppId: (appId) => set({ appId }),
    }),
    { name: 'admin-app-context', storage: createJSONStorage(() => localStorage) },
  ),
);
